module.exports = __webpack_public_path__ + "static/media/soundcloud-circle-button.a062b5a4.svg";